export const originUrl = `${window.location.protocol}//${window.location.host}`

export const stripeDashboardUrl = 'https://dashboard.stripe.com'
export const todokusuriUrl = 'https://todokusuri.com/todokusuri/'
export const todokusuriClinicUrl = 'https://todokusuri.com/clinic/'
export const todokusuriDocPath = '/docs/todokusuri_clinic_information.png'
